import { render, staticRenderFns } from "./BuscarMunicipio.vue?vue&type=template&id=20511a91&scoped=true"
import script from "./BuscarMunicipio.vue?vue&type=script&lang=js"
export * from "./BuscarMunicipio.vue?vue&type=script&lang=js"
import style0 from "./BuscarMunicipio.vue?vue&type=style&index=0&id=20511a91&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20511a91",
  null
  
)

export default component.exports